<!-- <div class="screen">
    <mat-toolbar class="toolbar">
        <mat-toolbar-row>
            <img src="{{assetPath}}imgs/logo-alt.svg" class="cloud">
        </mat-toolbar-row>
    </mat-toolbar> -->
    <div class="main cloud">
      <!-- EIM-17588 Removing Nogg image -->
      <p class="title">{{title}}</p>
      <p class="message">{{message}}</p>
    </div>
<!-- </div> -->

